<template>
  <va-sidebar
    class="pos"

    align="left"
    :minimized="minimized"
  >
    <template slot="menu">
      <template v-for="(item, key) in items">
        <va-sidebar-link-group
          style="text-align: left !important"
          class="txt-deco"
          :key="key"
          :minimized="minimized"
          :icon="[
            'sidebar-menu-item-icon vuestic-iconset',
            item.meta.iconClass,
          ]"
          v-if="item.children"
          :title="$t(item.displayName)"
          :children="item.children"
        >
          <va-sidebar-link
            v-for="(subMenuItem, key) in item.children"
            :key="key"
            class="txt-deco"
            :to="{ path: subMenuItem.path }"
            :title="$t(subMenuItem.displayName)"
            style="text-decoration: none !important"
          />
        </va-sidebar-link-group>
        <va-sidebar-link
          v-else
          :key="key"
          class="txt-deco"
          style="text-decoration: none !important"
          :minimized="minimized"
          :activeByDefault="item.path === $route.path"
          :icon="[
            'sidebar-menu-item-icon vuestic-iconset',
            item.meta.iconClass,
          ]"
          :to="{ path: item.path }"
        >
          <span slot="title">{{ $t(item.displayName) }}</span>
        </va-sidebar-link>
      </template>
    </template>
  </va-sidebar>
</template>

<script>
import { navigationRoutes } from './NavigationRoutes'
export default {
  name: 'app-sidebar',
  components: {},
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      // items: navigationRoutes.routes,
      // analystItems: navigationRoutes.analystRoutes,
    }
  },
  mounted () {
    // console.log("sndst",this.$store.state.userType)
  },
  computed: {

    items () {
      if (localStorage.getItem('userType') == 0) return navigationRoutes.routes
      else if (localStorage.getItem('userType') == 2) { return navigationRoutes.analystRoutes }
    },
  },
}
</script>
<style >
.txt-deco {
  text-decoration: none !important;
}
a {
  text-decoration: none !important;
}
.va-sidebar-link {
  text-decoration: none !important;
}
.va-sidebar-link:hover {
  text-decoration: none !important;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 640px) {
  .pos {
    position: absolute !important;
  }
}
</style>
